import PropTypes from 'prop-types';

import './BookButton.css';
import { BarsLoadingIndicator } from 'components/common/barsLoadingIndicator';
import { useSelector } from 'react-redux';

const BookButton = ({
    as: Tag = 'a',
    currencySymbol,
    price,
    text,
    url,
    variant,
    className,
    noPrice,
    onClick,
    isDirect,
    noRedirect = false,
    isLoading = false,
}) => {
    if (variant === 'default' && !text) {
        return null;
    }
    const rooms = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice?.rooms || 1
    );
    const props = {
        onClick: onClick,
    };
    if (isDirect || noRedirect) {
        url = '';
        // delete props.onClick;
        // onClick = null;
    }

    if (
        (!price || price === '0' || !text || (!url && !isDirect)) &&
        (variant === 'member' || variant === 'non-member') &&
        !noPrice
    ) {
        return null;
    }

    let additionalProps = {};

    if ((Tag === 'a' && !isDirect) || !noRedirect) {
        additionalProps = {
            href: url,
            target: '_blank',
            rel: 'noopener noreferrer',
        };
    }

    return (
        <Tag
            role="button"
            className={`ab-book-button ab-book-button--${variant} ${className}`}
            tabIndex="0"
            aria-disabled="false"
            {...additionalProps}
            {...props}
        >
            <div className="ab-book-button-container">
                <div className="ab-book-button-content">
                    {isLoading ? (
                        <>
                            <BarsLoadingIndicator
                                classes="ab-bars-loading-indicator--white"
                                size={11}
                            />
                        </>
                    ) : (
                        <>
                            <span>{text}</span>{' '}
                            <>
                                {!!price && (
                                    <span
                                        className={`ab-book-button-price ${
                                            price?.toString()?.length >= 5 &&
                                            'small-text'
                                        }`}
                                    >
                                        {rooms > 1 && `${rooms} x `}
                                        {`${price}${currencySymbol}`}
                                    </span>
                                )}
                            </>
                        </>
                    )}
                </div>
            </div>
        </Tag>
    );
};

BookButton.propTypes = {
    as: PropTypes.oneOf(['a', 'button']),
    currencySymbol: PropTypes.string,
    price: PropTypes.string,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    className: PropTypes.string,
    noPrice: PropTypes.bool,
    noRedirect: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'member', 'non-member']),
    onClick: PropTypes.func,
    isDirect: PropTypes.bool,
    isLoading: PropTypes.bool,
};

BookButton.defaultProps = {
    text: '',
    url: '',
    variant: 'default',
};

export default BookButton;
